<template lang="pug">
div
  UiCardSection
    UiStack
      UiStackItem(fill)
        .ui-card-section-title {{ $t("resellers.tabs.companies") }}
      UiStackItem
        UiButton(
          @click="exportToExcel"
          icon="FileDownload"
        ) {{ $t("resellers.export_to_excel") }}
  UiCardSection
    RestTable(
      namespace="reseller_companies"
      :headers="headers"
      ref="resellerCompaniesTable"
      :fetchHandler="getData"
      embed
    )
      template(#filters="{ filters, updateFilters }")
        UiCardSection
          UiStack
            UiStackItem
              UiFormGroup(
                :label="$t('automation.name')"
                label-for="company-name-input"
                label-cols="4"
              )
                UiInput#company-name-input(
                  type="search"
                  :modelValue="filters.search"
                  @update:modelValue="updateFilters({ search: $event })"
                  inputSize="40"
                )
            UiStackItem
              UiFormGroup(
                :label="$t('companies.basic.netvisor_organization_id')"
                label-for="business-id-input"
                label-cols="4"
              )
                UiInput#business-id-input(
                  :modelValue="filters.netvisor_organization_id"
                  type="search"
                  @update:modelValue="updateFilters({ netvisor_organization_id: $event })"
                  inputSize="40"
                )
      template(#cell:company_name="{ item }")
        RouterLink(
          :to="`/companies/${item.id}/edit`"
          label="item.company_name"
        ) {{ item.company_name }}
</template>
<script>
import router from "@/router";
import ApiResellers from "@/api/resellers.js";

export default {
  data() {
    return {
      headers: [
        {
          key: "id",
          label: "#",
          sortable: true,
          squeeze: true,
        },
        {
          key: "company_name",
          label: "Name",
          sortable: true,
        },
        {
          key: "netvisor_organization_id",
          label: "BusinessId",
          sortable: true,
        },
        {
          key: "invoice_automation",
          label: "Invoice Automation",
          sortable: false,
        },
        {
          key: "set_dimensions",
          label: "Set Dimensions",
          sortable: false,
        },
      ],
    };
  },

  methods: {
    getData(pagination, config) {
      return ApiResellers.fetchResellerCompanies(
        this.$route.params.id,
        pagination,
        config,
      ).then((resp) => {
        return {
          items: resp.data.reseller_companies,
          meta: resp.data.meta,
        };
      });
    },
    goBack() {
      router.push("/resellers");
    },
    exportToExcel() {
      ApiResellers.exportToExcel(this.$route.params.id)
        .then((resp) => {
          let fileURL = window.URL.createObjectURL(new Blob([resp.data]));
          let fileLink = document.createElement("a");
          fileLink.href = fileURL;
          fileLink.setAttribute("download", `reseller_companies.xlsx`);
          document.body.appendChild(fileLink);
          fileLink.click();
        })
        .catch((e) => {});
    },
  },
};
</script>
